import axios, { AxiosResponse } from 'axios';

import { getApiLink } from '../api';
import { useData } from '../hooks/useData';
import { iArticleReference__API } from '../apiSchema';
import { ArticleReference } from '../models/ArticleReference';

export async function getNewsArticleReferences(articleId: number): Promise<ArticleReference[]> {
    const response: AxiosResponse<iArticleReference__API[]> = await axios.get(
        getApiLink('NewsArticle/GetNewsReferenceArticles', { newsArticleId: articleId })
    );

    return (response?.data || []).map((r) => new ArticleReference({ apiModel: r }));
}

export default function useGetNewsArticleReferences(articleId: number) {
    return useData<ArticleReference[]>([], getNewsArticleReferences, articleId);
}
